export default {"src":"/_next/static/media/eop.413a8fa7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};